export default __webpack_public_path__ + "images/981abcf7117143efb748a24168137a1d-hand_icon.svg";